import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const ErrorMessage = ({ message }) => {
    if (!message) {
        return null;
    }

    return <Styled.ErrorMessage>{message}</Styled.ErrorMessage>;
};

ErrorMessage.defaultProps = {
    message: null
};

ErrorMessage.propTypes = {
    message: PropTypes.string
};

export default ErrorMessage;
